import React, { useState, useEffect, useContext } from 'react';
import mockUser from './mockData.js/mockUser';
import mockRepos from './mockData.js/mockRepos';
import mockFollowers from './mockData.js/mockFollowers';
import axios from 'axios';

const rootUrl = 'https://api.github.com';

const GithubContext = React.createContext();

//Provider, consumer

const GithubProvider = ({ children }) => {
  const [githubUser, setGithubUser] = useState(mockUser);
  const [repos, setRepos] = useState(mockRepos);
  const [followers, setFollowers] = useState(mockFollowers);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ show: false, msg: '' });

  const searchUsers = async (user) => {
    toggleError();
    setLoading(true);
    const response = await axios(`${rootUrl}/users/${user}`).catch((err) =>
      console.log(err)
    );
    console.log(response);
    if (response) {
      setGithubUser(response.data);
      const { repos_url, followers_url } = response.data;
      //get repos and followers
      await Promise.allSettled([
        axios(`${repos_url}?per_page=100`),
        axios(`${followers_url}?per_page=100`),
      ]).then((results) => {
        const [repos, followers] = results;
        const status = 'fulfilled';
        if (repos.status === status) setRepos(repos.value.data);
        if (followers.status === status) setFollowers(followers.value.data);
      });
    } else {
      toggleError(true, `No such user exists. Try again!`);
    }
    setLoading(false);
  };

  //requests loading
  const [rateLimit, setRateLimit] = useState(0);

  //check rate
  const checkRateLimit = () => {
    axios(`${rootUrl}/rate_limit`)
      .then(({ data }) => {
        let {
          rate: { remaining },
        } = data;
        setRateLimit(remaining);
        if (remaining === 0) {
          toggleError(
            true,
            `Sorry! You're out of requests. Try again in an hour.`
          );
        }
      })
      .catch((err) => console.log(err));
  };
  //error stuff goes here
  function toggleError(show = false, msg = '') {
    setError({ show, msg });
  }

  useEffect(checkRateLimit, [followers]);

  return (
    <GithubContext.Provider
      value={{
        githubUser,
        repos,
        followers,
        loading,
        rateLimit,
        error,
        searchUsers,
      }}
    >
      {children}
    </GithubContext.Provider>
  );
};

//exporting all contexts
export const useGlobalContext = () => {
  return useContext(GithubContext);
};

export { GithubContext, GithubProvider };
